import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';

import { v4 as uuidv4 } from 'uuid';

import { Dealer } from '../models/dealer.model';
import { OrderStateModel } from '@shared/models/order.model';
import { DealerStateSelectors } from '../states/dealer/dealer-state.selectors';
import { UserSelectors } from '../states/user/user.selectors';
import { User } from '@core/models/user.model';
import { OrderSelectors } from '@sales/states/order/order.selectors';
import { CustomerSelectors } from '@sales/modules/details/states/customer.selectors';
import { PrivateCustomer } from '@sales/modules/details/models/private-customer.model';
import { OrderMetadataStateSelectors } from '../states/order-metadata/order-metadata-selectors';
import { OrderMetadataStateModel } from '../states/order-metadata/order-metadata.type';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  private store = inject(Store);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const appdata = window['DIEGO_APP_DATA'];
    const apiUrl = appdata.apiUrl;

    const user = this.store.selectSnapshot<User>(UserSelectors.getUser);
    const order = this.store.selectSnapshot<OrderStateModel>(OrderSelectors.getState);
    const customerId = this.store.selectSnapshot<string>(CustomerSelectors.customerId);
    const privateCustomer = this.store.selectSnapshot<PrivateCustomer>(CustomerSelectors.privateCustomer);
    const dealer = this.store.selectSnapshot<Dealer>(DealerStateSelectors.activeDealer);
    const orderMetadata = this.store.selectSnapshot<OrderMetadataStateModel>(OrderMetadataStateSelectors.getState);

    let updatedRequest = req.clone({
      withCredentials: true,
    });

    if (updatedRequest.url.indexOf(apiUrl) !== -1 && dealer && order) {
      // Clone the request and replace the original headers with
      // cloned headers, updated with the additional data.
      updatedRequest = req.clone({
        headers: updatedRequest.headers
          .append('X-Correlation-Id', uuidv4()) // generate a new correlation id for each request
          .append('x-header-dealer-id', dealer.dealerId || '')
          .append('x-header-dealer-code', dealer.dealerCode || '')
          .append('x-header-customer-id', customerId || orderMetadata?.customerId || '')
          .append('x-header-order-service-id', String(order.orderServiceId || orderMetadata?.orderServiceId || ''))
          .append('x-header-order-capture-id', String(order.orderCaptureId || orderMetadata?.orderCaptureId || ''))
          .append('x-header-user-id', user.sub || '')
          .append('x-header-msisdn', privateCustomer.phone || '')
          .append('x-header-client-version', appdata.clientVersion),
        withCredentials: true,
      });
    }

    // send cloned request with header to the next handler.
    return next.handle(updatedRequest);
  }
}
